export default __webpack_public_path__ + "static/media/moons.3bb838ce.svg";